import axios from 'axios'

function authHeaders() {
  const token = localStorage.getItem('jwt_token')
  return token ? { Authorization: `Bearer ${token}` } : {}
}

export async function fetchAdminMoments({ page = 1, pageSize = 20, userId, keyword, status } = {}) {
  const res = await axios.post(
    '/api/v1/admin/moment/list',
    {
      page,
      pageSize,
      userId: userId || undefined,
      keyword: keyword || undefined,
      status: status || undefined
    },
    { headers: authHeaders() }
  )
  if (res.data?.code !== 200) throw new Error(res.data?.message || '加载失败')
  return res.data.data || { moments: [], total: 0 }
}

export async function blockAdminMoment(momentId, block = true) {
  const res = await axios.post(
    '/api/v1/admin/moment/block',
    { momentId, block },
    { headers: authHeaders() }
  )
  if (res.data?.code !== 200) throw new Error(res.data?.message || '操作失败')
  return res.data
}

export async function deleteAdminMoment(momentId) {
  const res = await axios.post(
    '/api/v1/admin/moment/delete',
    { momentId },
    { headers: authHeaders() }
  )
  if (res.data?.code !== 200) throw new Error(res.data?.message || '删除失败')
  return res.data
}
